import React from 'react';
import Grid from '@material-ui/core/Grid';
import ContentParser from '../../../library/ContentParser';
import ActionsBarContainer from '../containers/ActionsBarContainer';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { SERVICE_INITIATION_ATTRIBUTES } from '../../../../constants/constants';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

export const ServiceAddPres = ({
  pageData,
  isMobile,
  match,
  setFormValues,
  formValues,
  setSaveHandler,
  showServiceDetails,
  isLoading,
  onValidate,
  validationError,
  isEmployeeSelected,
  isDraft,
  updateValidationErrorState,
}) => {
  if (!pageData || isLoading) {
    return (
      <div style={{ marginTop: '5rem' }}>
        <Spinner size={70} />
      </div>
    );
  }

  const { pageId } = match.params;
  const { menus, isSubmitted } = pageData;
  const { menuName, numColumns } =
    pageId && menus && menus.length && menus[0].subMenu.length ? menus[0].subMenu.filter(m => m.pageId === pageId)[0] : {};

  const changeInputPageData = pageData => {
    pageData &&
      pageData.pageElements &&
      pageData.pageElements.forEach((pageElement, index) => {
        switch (pageElement.attributeName) {
          case SERVICE_INITIATION_ATTRIBUTES.VIP_EXECUTIVE:
            if (pageElement.value && pageElement.value.toLowerCase() === 'yes') {
              pageData.pageElements[index].value = 'True';
            }
            if (pageElement.value && pageElement.value.toLowerCase() === 'no') {
              pageData.pageElements[index].value = 'False';
            }
            break;
          default:
            break;
        }
      });
    return pageData;
  };

  return (
    <div>
      <section className={fnShowNewDashboard() ? 'ssi-add-initiation margin-content ssi-search-box' : 'ssi-add-initiation margin-content'}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <div className="ssi-add-inner">
              <ContentParser
                key={pageData.pageId}
                pageId={pageData.pageId}
                data={changeInputPageData(pageData)}
                onChange={setFormValues}
                numberOfColumns={isMobile ? 1 : numColumns || 3}
                forceNumberOfColumns={isMobile}
                showLabels={false}
                debug={false}
                readOnly={isSubmitted}
                onValidate={onValidate}
              />
            </div>
          </Grid>
        </Grid>
      </section>
      <ActionsBarContainer
        progressTitle={menuName}
        showServiceDetails={showServiceDetails}
        formValues={formValues}
        isPageVariant={true}
        routeParams={match.params}
        setSaveHandler={setSaveHandler}
        validationError={validationError}
        isEmployeeSelected={isEmployeeSelected}
        isDraft={isDraft}
        isFromSSI={true}
        updateValidationErrorState={updateValidationErrorState}
      />
    </div>
  );
};

export default ServiceAddPres;
